
<div
  :class="containerStyle"
  :style="containerStyleVar"
  :title="containerInfo"
  v-on:mouseenter="mouseEnter"
  v-on:mouseleave="mouseLeave"
  v-on:mousedown="mouseDown"
  v-on:mouseup="mouseUp"
  ref="containerRef"
>
  <div v-if="!selectedFile?.canceled" class="item-body">
    <div class="item-image">
      <img
        :src="selectedFile?.thumbnail"
        loading="lazy"
        :alt="selectedFile?.fullname()"
      />
    </div>

    <span class="item-tools" v-if="toolsShow">
      <span
        class="upload-icon icon-rename"
        title="重命名"
        v-on:click="rename()"
        v-if="renameEnable && !uploadInstance.getSettings().readonly"
      ></span>
      <span
        class="upload-icon icon-view"
        title="查看"
        v-if="viewEnable"
        v-on:click="view()"
      ></span>
      <span
        class="upload-icon icon-download"
        title="保存"
        v-if="saveEnable"
        v-on:click="save()"
      ></span>
      <span
        class="upload-icon icon-remove"
        title="删除"
        v-on:click="remove()"
        v-if="!uploadInstance.getSettings().readonly"
      ></span>
    </span>

    <slot
      :selectedFile="selectedFile"
      :rename="renderData.rename"
      :funs="{
        setRenameInputRef: setRenameInputRef,
        renameKeydown: renameKeydown,
        renameDone: renameDone,
      }"
      :loadingInfo="loadingInfo"
      :loadingShow="loadingShow"
    ></slot>

    <div v-if="selectedFile?.paused" class="item-sub sub-paused">暂停</div>
    <div
      v-if="selectedFile?.done && !uploadInstance.getSettings().readonly"
      class="item-sub sub-done"
    >
      完成
    </div>
    <div v-if="selectedFile?.error" class="item-sub sub-error">错误</div>
  </div>
</div>
